// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2BHVM","header":"Messages_header__1CqZA"};